const styles = (theme) => ({
	paper: {
		p: 2,
		mb: 2,
	},
	chipVigencia: {
		backgroundColor: theme.palette.chip.background.success,
		color: theme.palette.chip.colorText.success,
		border: "0.6px solid ",
		borderColor: theme.palette.chip.colorText.success,
		borderRadius: "10px",
		height: "20px",
		width: "100%",
	},
	chipProxima: {
		backgroundColor: theme.palette.chip.background.high,
		color: theme.palette.chip.colorText.high,
		border: "0.6px solid ",
		borderColor: theme.palette.colors.orange.medium,
		borderRadius: "10px",
		height: "20px",
		width: "100%",
	},
	chipExpirado: {
		backgroundColor: theme.palette.chip.background.critical,
		color: theme.palette.chip.colorText.critical,
		border: "0.1px solid ",
		borderColor:
			theme.palette.mode === "dark"
				? theme.palette.colors.red.darker
				: theme.palette.colors.red.light,
		borderRadius: "10px",
		height: "20px",
		width: "100%",
	},
	autocompleteServicos: {
		width: 300,
		mt: 2,
	},
	pagination: {
		marginTop: "auto",
		display: "flex",
		justifyContent: "center",
		mt: 2,
	},
	containerTextNoTicketsError: {
		position: "absolute",
		left: "45%",
		top: "45%",
		transform: "translateX(-50%)",
		"@media (max-width: 700px)": {
			left: "38%",
		},
		"@media (max-width: 600px)": {
			left: "40%",
			top: "20%",
		},
		"@media (max-width: 430px)": {
			left: "38%",
			top: "18%",
		},
	},
	containerNoTickets: {
		width: "100%",
		height: "100%",

		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		pt: 2,
	},
	pageBox: {
		display: "flex",
		flexDirection: "column",
		gap: 0,
		maxWidth: "100%",
	},
	searchField: {
		width: "100%",
		maxWidth: 500,

		display: "flex",

		fontSize: "0.75rem", // diminui fonte geral
		"& .MuiInputBase-input": {
			padding: "8px 8px", // padding interno reduzido
			fontSize: "0.75rem", // fonte do input
		},
		"& .MuiInputLabel-root": {
			fontSize: "0.75rem", // fonte da label
		},
		"@media (max-width: 1350px)": {
			width: "100%",
		},
	},
	boxFilters: {
		display: "flex",
		flexDirection: "row",
		gap: 1,
		"@media (max-width: 1350px)": {
			flexDirection: "column",
		},

		width: "100%",
	},
});

export default styles;
